export enum BillingsOrderForwardBillingsDownloadRequestBillingStatus {
  CREATED = "CREATED",
  ACCEPTED = "ACCEPTED",
  REJECTED = "REJECTED",
  REOPENED = "REOPENED",
  REOPEN_REQUEST = "REOPEN_REQUEST",
}

export enum BillingsOrderForwardBillingsDownloadRequestOrder {
  DATE_AT_ASC = "DATE_AT_ASC",
  DATE_AT_DESC = "DATE_AT_DESC",
  HUMAN_ID_ASC = "HUMAN_ID_ASC",
  HUMAN_ID_DESC = "HUMAN_ID_DESC",
  DISTANCE_ASC = "DISTANCE_ASC",
  DISTANCE_DESC = "DISTANCE_DESC",
  DISTANCE_RATE_ASC = "DISTANCE_RATE_ASC",
  DISTANCE_RATE_DESC = "DISTANCE_RATE_DESC",
  DISTANCE_AMOUNT_ASC = "DISTANCE_AMOUNT_ASC",
  DISTANCE_AMOUNT_DESC = "DISTANCE_AMOUNT_DESC",
  HALTING_AMOUNT_ASC = "HALTING_AMOUNT_ASC",
  HALTING_AMOUNT_DESC = "HALTING_AMOUNT_DESC",
  HIGHWAY_CHARGE_ASC = "HIGHWAY_CHARGE_ASC",
  HIGHWAY_CHARGE_DESC = "HIGHWAY_CHARGE_DESC",
  TOTAL_AMOUNT_ASC = "TOTAL_AMOUNT_ASC",
  TOTAL_AMOUNT_DESC = "TOTAL_AMOUNT_DESC",
  PRODUCER_ASC = "PRODUCER_ASC",
  PRODUCER_DESC = "PRODUCER_DESC",
  CONSUMER_ASC = "CONSUMER_ASC",
  CONSUMER_DESC = "CONSUMER_DESC",
  BILLING_MODEL_ASC = "BILLING_MODEL_ASC",
  BILLING_MODEL_DESC = "BILLING_MODEL_DESC",
}

export type BillingsOrderForwardBillingsDownloadQueryParams = {
  order?: BillingsOrderForwardBillingsDownloadRequestOrder;
  taxi_corporation_id?: string;
  start_time_since?: string;
  start_time_to?: string;
  human_id?: number;
  producer?: string;
  consumer?: string;
  status?: BillingsOrderForwardBillingsDownloadRequestBillingStatus;
};

type BillingsOrderForwardBillingsDownloadRequest = {
  order?: BillingsOrderForwardBillingsDownloadRequestOrder;
  taxiCorporationId?: string;
  startTimeSince?: string;
  startTimeTo?: string;
  humanId?: number;
  producer?: string;
  consumer?: string;
  status?: BillingsOrderForwardBillingsDownloadRequestBillingStatus;
};

export default BillingsOrderForwardBillingsDownloadRequest;
